import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://sandbox-api.payplanadvantage.com/pu/v1',
  cybersourceUrl: 'https://sandbox-cybersource.payplanadvantage.com',
  apimPbKey: '2b50f1d8b8fe420d94c615bce094766f',
  shortenApiUrl: 'https://sandbox-api.payplanadvantage.com/pa/v2',
  shortenApimPbKey: '59fd084c859846c19706f6fa32cf16fb',
  rsaPbKey:
    '-----BEGIN PUBLIC KEY-----\nMIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQBgMkk3mDaCcoASTvFXNt1U\nIGbL4BfECAo7ziKUOkp/CVvp7yREUrG7Kfg1F8GCL5k1q8YL1/qWIBb89CBiVlwV\nf/2lgFGquAqRSHwt2KhwaRWhkzzFTI3KBLozETw9IHt5G4PBGB9m3kOcgWZtmt2J\nWpQplsPTGLL23IL83SMJpD8OuPmiWNJ2myB8BkKstUF47L/DPsjmERsk8aFTlfJg\nhwvaVxkzHzl5QyX0fkSB5HXZi8gxBX7YxocSkEWdMPPH+nOeAwooeNNHD45ZWVPn\nFRp6NEzjCkpnEskzbbSiWNNaVlidkbPEmlpEj3d/HF0TY2TNk+llx58KGI/J4N8d\nAgMBAAE=\n-----END PUBLIC KEY-----'
};